import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export default function AdminWelcome() {
  const [s, setS] = useState(null);
  const [f, setF] = useState({ spots_left: "", amount: "" });
  const load = () => api.get("/admin/welcome").then(({ data }) => { setS(data); setF({ spots_left: String(data.spots_left), amount: String(data.amount) }); });
  useEffect(() => { load(); }, []);
  const save = async (patch) => {
    try {
      const { data } = await api.post("/admin/welcome", { on: s.on, spots_left: Number(f.spots_left), amount: Number(f.amount), ...patch });
      setS(data); setF({ spots_left: String(data.spots_left), amount: String(data.amount) }); toast.success("Welcome bonus updated");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  return (
    <div className="glass rounded-2xl p-6 space-y-4 mb-6" data-testid="admin-welcome">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h3 className="font-display text-xl text-amber-100 flex items-center gap-2"><Gift className="w-5 h-5 text-amber-300" />Welcome bonus</h3>
        <label className="flex items-center gap-3 text-sm text-slate-300">{s.on ? "On" : "Paused"}
          <Switch data-testid="admin-welcome-switch" checked={s.on} onCheckedChange={(on) => save({ on })} /></label>
      </div>
      <p data-testid="admin-welcome-count" className="text-sm text-slate-300"><b className="text-amber-200">{s.given}</b> of {s.spots} given · {s.spots_left} spots left · {s.amount.toLocaleString()} credits each</p>
      <div className="h-2 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-gradient-to-r from-amber-500 to-amber-300 transition-[width] duration-700" style={{ width: `${s.spots ? (100 * s.given) / s.spots : 0}%` }} /></div>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs text-slate-400">Spots left<Input data-testid="admin-welcome-spots" value={f.spots_left} onChange={(e) => setF({ ...f, spots_left: e.target.value.replace(/\D/g, "") })} className="bg-slate-950 h-10 w-32 mt-1" /></label>
        <label className="text-xs text-slate-400">Credits each<Input data-testid="admin-welcome-amount" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value.replace(/\D/g, "") })} className="bg-slate-950 h-10 w-32 mt-1" /></label>
        <button data-testid="admin-welcome-save" onClick={() => save({})} className="ember-btn px-5 h-10 rounded-full text-xs">SAVE</button>
      </div>
      <details className="text-sm">
        <summary data-testid="admin-welcome-list-toggle" className="cursor-pointer text-slate-300">Who got it ({s.recipients.length})</summary>
        <ul className="mt-3 space-y-1 max-h-64 overflow-y-auto" data-testid="admin-welcome-list">
          {s.recipients.map((r) => <li key={r.user_id} className="flex justify-between gap-4 text-xs text-slate-400"><span>#{r.no} · {r.email}</span><span>{new Date(r.at).toLocaleString()}</span></li>)}
          {!s.recipients.length && <li className="text-xs text-slate-500">Nobody yet. It's given automatically to each new account.</li>}
        </ul>
      </details>
    </div>
  );
}
